import { render, staticRenderFns } from "./category-tree.vue?vue&type=template&id=06743c03&"
import script from "./category-tree.vue?vue&type=script&lang=ts&"
export * from "./category-tree.vue?vue&type=script&lang=ts&"
import style0 from "./category-tree.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports